import { IPaginatedRequest } from '@cbgms/api/request'
import * as types from './types'
import {
  DELETEResponse,
  GETProductGroupsResponse,
  IProductGroup,
  POSTProductGroupImportResponse,
  POSTProductGroupTranslationBody,
  UUIDResponse
} from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const getAllProductTrees = (params: IPaginatedRequest) => ({
  type: [types.LOAD_PRODUCT_TREES, types.LOAD_PRODUCT_TREES_SUCCESS, types.LOAD_PRODUCT_TREES_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: '/modules/product-groups',
      params
    }
  }
})

export const getProductTree = (uuid: string) =>
  AsyncAction<GETProductGroupsResponse>({
    type: [types.LOAD_PRODUCT_TREE, types.LOAD_PRODUCT_TREE_SUCCESS, types.LOAD_PRODUCT_TREE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: `/modules/product-groups/${uuid}`
      }
    }
  })

export const copyProductGroup = (UUID: string) =>
  AsyncAction<UUIDResponse>({
    type: [types.COPY_PRODUCT_TREE, types.COPY_PRODUCT_TREE_SUCCESS, types.COPY_PRODUCT_TREE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: '/modules/product-groups/copy',
        data: {
          UUID
        }
      }
    }
  })

export const createProductGroup = (data: Partial<IProductGroup>) =>
  AsyncAction<UUIDResponse>({
    type: [types.CREATE_SUPPORT_GROUP_CATEGORY, types.CREATE_SUPPORT_GROUP_CATEGORY_SUCCESS, types.CREATE_SUPPORT_GROUP_CATEGORY_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: '/modules/product-groups',
        data
      }
    }
  })

export const updateProductGroup = (uuid: string, data: Partial<IProductGroup>) => ({
  type: [types.UPDATE_SUPPORT_GROUP_CATEGORY, types.UPDATE_SUPPORT_GROUP_CATEGORY_SUCCESS, types.UPDATE_SUPPORT_GROUP_CATEGORY_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'PUT',
      url: `/modules/product-groups/${uuid}`,
      data
    }
  }
})

export const deleteProductGroup = (uuid: string, dryRun?: boolean) =>
  AsyncAction<DELETEResponse>({
    type: [types.DELETE_SUPPORT_GROUP_CATEGORY, types.DELETE_SUPPORT_GROUP_CATEGORY_SUCCESS, types.DELETE_SUPPORT_GROUP_CATEGORY_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'DELETE',
        url: `/modules/product-groups/${uuid}`,
        params: {
          DryRun: dryRun
        }
      }
    }
  })

export const setProductGroupTranslation = (uuid: string, data: POSTProductGroupTranslationBody) => ({
  type: [types.SET_SUPPORT_GROUP_TRANSLATION, types.SET_SUPPORT_GROUP_TRANSLATION_SUCCESS, types.SET_SUPPORT_GROUP_TRANSLATION_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'PUT',
      url: `/modules/product-groups/${uuid}/translation`,
      data
    }
  }
})

export const exportProductGroup = (uuid: string) => ({
  type: [types.EXPORT_PRODUCT_TREE, types.EXPORT_PRODUCT_TREE_SUCCESS, types.EXPORT_PRODUCT_TREE_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: `/modules/product-groups/${uuid}/export`
    }
  }
})

export const importProductGroup = (file: File) =>
  AsyncAction<POSTProductGroupImportResponse>({
    type: [types.IMPORT_PRODUCT_TREE, types.IMPORT_PRODUCT_TREE_SUCCESS, types.IMPORT_PRODUCT_TREE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: `/modules/product-groups/import`,
        data: file
      }
    }
  })
